export default __webpack_public_path__ + "static/media/card3.d7704fc2.jpeg";